// extracted by mini-css-extract-plugin
export default {"SwitchInput":"Switch_SwitchInput__d7tAv","Switch":"Switch_Switch__ndSKZ","Slider":"Switch_Slider__A0-bW","Round":"Switch_Round__xfW3d"};